<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <b-row class="m-0">
        <b-col
          v-for="(item, index) in [1, 2, 3, 4, 5]"
          :key="`a-${index}`"
          cols="12"
          class="padding-0 margin-bottom-16"
        >
          <b-skeleton width="100%"></b-skeleton>
        </b-col>
      </b-row>
    </template>
    <slot name="default"></slot>
  </b-skeleton-wrapper>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
